import { useLang } from "@/i18n";

export function Marquee() {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div className="marquee" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track">
        {[...items, ...items].map((m, i) => (
          <span className="marquee-item" key={i}>
            {m}
            <i className="marquee-dot" />
          </span>
        ))}
      </div>
    </div>
  );
}
